module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_cvi_r1.htm"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_tp_r1.htm"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c01_r1.htm"
    }
  }, [_vm._v("CHAPTER ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c02_r1.htm"
    }
  }, [_vm._v("CHAPTER TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c03"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c03_r1.htm"
    }
  }, [_vm._v("CHAPTER THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c04"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c04_r1.htm"
    }
  }, [_vm._v("CHAPTER FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c05"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c05_r1.htm"
    }
  }, [_vm._v("CHAPTER FIVE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c06"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c06_r1.htm"
    }
  }, [_vm._v("CHAPTER SIX")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c07"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c07_r1.htm"
    }
  }, [_vm._v("CHAPTER SEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c08"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c08_r1.htm"
    }
  }, [_vm._v("CHAPTER EIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c09"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c09_r1.htm"
    }
  }, [_vm._v("CHAPTER NINE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "p01"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_p01_r1.htm"
    }
  }, [_vm._v("MY ADVENTURES IN HOLLYWOOD — PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c10"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c10_r1.htm"
    }
  }, [_vm._v("CHAPTER TEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "p02"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_p02_r1.htm"
    }
  }, [_vm._v("MY ADVENTURES IN HOLLYWOOD — PART TWO")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c11"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c11_r1.htm"
    }
  }, [_vm._v("CHAPTER ELEVEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c12"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c12_r1.htm"
    }
  }, [_vm._v("CHAPTER TWELVE")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c13"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c13_r1.htm"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c14"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c14_r1.htm"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c15"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c15_r1.htm"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c16"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c16_r1.htm"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c17"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c17_r1.htm"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "c18"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_c18_r1.htm"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "bm"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_bm_r1.htm"
    }
  }, [_vm._v("Preview")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "als"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_als_r1.htm"
    }
  }, [_vm._v("Also by Lois Duncan")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "ata"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_ata_r1.htm"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "cop"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9780545388856_epub_cop_r1.htm"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f34ab02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780545388856_epub_toc_r1.vue
// module id = 63
// module chunks = 0